import React from "react";
import { Link } from "react-router-dom";
import react1 from '../assets/react1.jpg'
import react from '../assets/react.jpg'
import "./AboutMe.css";

const AboutMe = () => {
  return (
    <div className="about">
      <div className="left">
        <h1>Who am i?</h1>
        <p>I am a full stack developer I specialize in Javascript, React & Nodejs i primarly build applications with the MERN stack</p>
        <Link to="/contact">
          <button className="btn">Contact Me</button>
        </Link>
      </div>
      <div className="right">
      <div className="img-container">
      <div className="img-stack top">
      <img src={react1} className="img" alt="front"/>
      </div>
      <div className="img-stack bottom">
      <img src={react} className="img" alt="front"/>
      </div>
      </div>
      </div>
    </div>
  );
};

export default AboutMe;
